import Icon from 'veui/components/Icon'
import { IconChevronDoubleRight } from 'dls-icons-vue'

Icon.register('chevron-double-right', IconChevronDoubleRight)
